import { ValueError } from "../error/ValueError.js";
import {} from "./path.js";
import { getOptionalURL, isURL } from "./url.js";
/** Default whitelist for URL schemes. */
const _SCHEMES = ["http:", "https:"];
/** Is an unknown value a URL object with an absolute path component? */
export function isLinkURL(value) {
    return isURL(value) && !!value.protocol;
}
/** Convert a possible URL to a URL or return `undefined` if conversion fails. */
export function getOptionalLinkURL(possible, base, schemes = _SCHEMES, hosts) {
    const url = getOptionalURL(possible, base);
    if (url && schemes.includes(url.protocol) && (!hosts || hosts.includes(url.host)))
        return url;
}
/** Convert a possible URL to a URL or return `undefined` if conversion fails. */
export function getLinkURL(possible, base, schemes, hosts) {
    const url = getOptionalLinkURL(possible, base, schemes, hosts);
    if (!url)
        throw new ValueError("Invalid link", possible);
    return url;
}
/** Convert a possible URL to a absolute URL string or return `undefined` if conversion fails. */
export function getOptionalLink(possible, base, schemes = _SCHEMES, hosts) {
    const url = getOptionalURL(possible, base);
    if (url && schemes.includes(url.protocol) && (!hosts || hosts.includes(url.host)))
        return url.href;
}
/** Convert a possible URL to an absolute URL string. */
export function getLink(possible, base, schemes, hosts) {
    return getLinkURL(possible, base, schemes, hosts).href;
}
